// The pages before sign-in — login, signup, password recovery, email confirmation.
export const auth = {
  'auth.email': 'ელ-ფოსტა',
  'auth.password': 'პაროლი',
  'auth.showPassword': 'პაროლის ჩვენება',
  'auth.hidePassword': 'პაროლის დამალვა',
  'auth.min6': 'მინიმუმ 6 სიმბოლო',
  'auth.err.min6': 'პაროლი მინიმუმ 6 სიმბოლო',
  'auth.err.weakPassword': 'ეს პაროლი ძალიან მარტივია ან ცნობილ გაჟონილ პაროლებს შორისაა — აირჩიე სხვა.',
  'auth.rights': 'ყველა უფლება დაცულია',
  'auth.terms': 'პირობები',
  'auth.privacy': 'კონფიდენციალურობა',
  'auth.welcome': 'კეთილი იყოს თქვენი მობრძანება!',
  'auth.backToLogin': 'შესვლის გვერდზე დაბრუნება',
  'auth.toLoginPage': 'შესვლის გვერდზე',
  'auth.linkExpired': 'ბმულს ვადა გაუვიდა',
  'auth.login.subtitle': 'ადმინ პანელში შესასვლელად ავტორიზაცია',
  'auth.login.fillBoth': 'შეავსეთ ელ-ფოსტა და პაროლი',
  'auth.login.unconfirmed': 'ელ-ფოსტა ჯერ დაუდასტურებელია — გახსენით რეგისტრაციის წერილი და დააჭირეთ ბმულს',
  'auth.login.resendLink': 'ბმულის ხელახლა გაგზავნა',
  'auth.login.resendFailed': 'ვერ გაიგზავნა — სცადეთ ერთ წუთში',
  'auth.login.resent': 'ახალი ბმული გამოგზავნილია — შეამოწმეთ ფოსტა (და სპამი)',
  'auth.login.wrong': 'არასწორი ელ-ფოსტა ან პაროლი',
  'auth.login.forgot': 'პაროლი დაგავიწყდათ?',
  'auth.login.submit': 'შესვლა',
  'auth.login.noAccount': 'არ გაქვს ანგარიში?',
  'auth.login.createShop': 'შექმენი მაღაზია',
  'auth.signup.fillAll': 'შეავსეთ ყველა ველი',
  'auth.signup.needTerms': 'რეგისტრაციისთვის საჭიროა პირობებზე თანხმობა',
  'auth.signup.badEmail': 'ჩაწერეთ სწორი ელ-ფოსტა, მაგ. shop@gmail.com',
  'auth.signup.tempEmail': 'დროებითი ელ-ფოსტით რეგისტრაცია არ შეიძლება — გამოიყენეთ თქვენი ნამდვილი ფოსტა',
  'auth.signup.taken': 'ეს ელ-ფოსტა უკვე რეგისტრირებულია',
  'auth.signup.failed': 'რეგისტრაცია ვერ მოხერხდა',
  'auth.signup.created': 'მაღაზია შექმნილია! კეთილი იყოს თქვენი მობრძანება',
  'auth.signup.takenHint': 'ეს ელ-ფოსტა უკვე რეგისტრირებულია — შედით სისტემაში, ან აღადგინეთ პაროლი',
  'auth.signup.rateLimited': 'ცოტა ხანში სცადეთ — ბმული ახლახან გაიგზავნა',
  'auth.signup.sendFailed': 'გაგზავნა ვერ მოხერხდა',
  'auth.signup.resent': 'ბმული ხელახლა გაიგზავნა — შეამოწმეთ სპამის საქაღალდეც',
  'auth.signup.confirmTitle': 'დაადასტურეთ ელ-ფოსტა',
  'auth.signup.confirmBody': 'გამოგზავნილია დადასტურების ბმული მისამართზე {email}. დააჭირეთ ბმულს — მაღაზია მაშინვე გაიხსნება. ბმული ერთი საათი მოქმედებს.',
  'auth.signup.sending': 'იგზავნება…',
  'auth.signup.resend': 'ბმული არ მოვიდა? ხელახლა გაგზავნა',
  'auth.signup.wrongEmail': 'არასწორი ფოსტა? უკან',
  'auth.signup.title': 'შექმენი შენი მაღაზია',
  'auth.signup.trial': '14 დღიანი უფასო საცდელი პერიოდი',
  'auth.signup.shopName': 'მაღაზიის სახელი',
  'auth.signup.shopNamePh': 'ჩემი მაღაზია',
  'auth.signup.agree': 'წავიკითხე და ვეთანხმები {terms} და {privacy}',
  'auth.signup.termsLink': 'მომსახურების პირობებს',
  'auth.signup.privacyLink': 'კონფიდენციალურობის პოლიტიკას',
  'auth.signup.version': 'ვერსია {v}',
  'auth.signup.submit': 'მაღაზიის შექმნა',
  'auth.signup.haveAccount': 'უკვე გაქვს ანგარიში?',
  'auth.forgot.enterEmail': 'შეიყვანეთ ელ-ფოსტა',
  'auth.forgot.rateLimited': 'ბევრი მოთხოვნა გაიგზავნა. სცადეთ რამდენიმე წუთში.',
  'auth.forgot.failed': 'წერილის გაგზავნა ვერ მოხერხდა. სცადეთ ხელახლა.',
  'auth.forgot.checkMail': 'შეამოწმეთ ფოსტა',
  'auth.forgot.sentBody': 'თუ {email} რეგისტრირებულია, პაროლის აღდგენის ბმული უკვე გზაშია. შეამოწმეთ სპამის საქაღალდეც.',
  'auth.forgot.anyDevice': '{b} კომპიუტერზე მოითხოვეთ და ტელეფონზე გახსენით — იმუშავებს. ვადა 1 საათია და ერთხელ გამოიყენება.',
  'auth.forgot.anyDeviceB': 'ბმული ნებისმიერ მოწყობილობაზე იხსნება.',
  'auth.forgot.title': 'პაროლის აღდგენა',
  'auth.forgot.subtitle': 'მიუთითეთ ელ-ფოსტა, რომლითაც შედიხართ სისტემაში',
  'auth.forgot.submit': 'აღდგენის ბმულის გაგზავნა',
  'auth.forgot.staffHint': 'მაღაზიის თანამშრომელი ხართ? პაროლს თქვენი მაღაზიის მფლობელიც შეგიცვლით.',
  'auth.reset.mismatch': 'პაროლები არ ემთხვევა',
  'auth.reset.same': 'ეს პაროლი უკვე გაქვთ — მიუთითეთ სხვა',
  'auth.reset.failed': 'პაროლის შეცვლა ვერ მოხერხდა. სცადეთ ხელახლა.',
  'auth.reset.done': 'პაროლი შეიცვალა — შედით ახალი პაროლით',
  'auth.reset.wrongBrowserTitle': 'ბმული სხვა მოწყობილობაზეა გახსნილი',
  'auth.reset.wrongBrowserBody': 'აღდგენის ბმული მუშაობს მხოლოდ იმ ბრაუზერში, საიდანაც მოთხოვნა გააკეთეთ. გაიმეორეთ მოთხოვნა აქედან — ამ მოწყობილობიდან — და ბმულიც აქვე გახსენით.',
  'auth.reset.expiredBody': 'აღდგენის ბმული ერთჯერადია და დროში შეზღუდული. მოითხოვეთ ახალი — ერთ წუთში მოვა.',
  'auth.reset.missingTitle': 'გვერდი პირდაპირ გაიხსნა',
  'auth.reset.missingBody': 'ეს გვერდი მხოლოდ ელ-ფოსტაზე მიღებული ბმულით იხსნება. თუ პაროლი დაგავიწყდათ, დაიწყეთ აღდგენა.',
  'auth.reset.again': 'აღდგენის ხელახლა მოთხოვნა',
  'auth.reset.newPassword': 'ახალი პაროლი',
  'auth.reset.forAccount': 'ანგარიშისთვის {email}',
  'auth.reset.repeat': 'გაიმეორეთ პაროლი',
  'auth.reset.save': 'პაროლის შენახვა',
  'auth.reset.after': 'შენახვის შემდეგ სისტემიდან გამოხვალთ და ახალი პაროლით შეხვალთ.',
  'auth.confirm.checking': 'ვამოწმებთ ბმულს…',
  'auth.confirm.done': 'ელ-ფოსტა დადასტურდა',
  'auth.confirm.welcome': 'კეთილი იყოს თქვენი მობრძანება {brand}-ში — მაღაზია იხსნება…',
  'auth.confirm.sameBrowser': 'გახსენით ბმული იმავე ბრაუზერში',
  'auth.confirm.incomplete': 'ბმული არასრულია',
  'auth.confirm.sameBrowserBody': 'ეს ბმული მხოლოდ იმ ბრაუზერში მუშაობს, საიდანაც დარეგისტრირდით. შედით სისტემაში იქიდან, ან მოითხოვეთ ახალი ბმული.',
  'auth.confirm.loginBody': 'შედით სისტემაში თქვენი ელ-ფოსტითა და პაროლით — თუ ფოსტა ჯერ დაუდასტურებელია, ახალ ბმულს იქვე გამოგიგზავნით.',
} as const
